// ==========================================
// 1. IMPORT ALL MODULAR CHAPTER FILES HERE
// ==========================================
// --- BP601T (Medicinal Chemistry III) Imports ---
import { PenicillinsNotes } from './Chapters/Penicillins';
import { CephalosporinsNotes } from './Chapters/Cephalosporins';
import { BetaLactamaseInhibitorsNotes } from './Chapters/BetaLactamaseInhibitors';
import { MonobactamsNotes } from './Chapters/Monobactams';
import { AminoglycosidesNotes } from './Chapters/Aminoglycosides';
import { TetracyclinesNotes } from './Chapters/Tetracyclines';
import { MacrolidesNotes } from './Chapters/Macrolides';
import { ClindamycinNotes } from './Chapters/Clindamycin';
import { ChloramphenicolNotes } from './Chapters/Chloramphenicol';
import { AntimalarialsNotes } from './Chapters/Antimalarials';
import { ProdrugsNotes } from './Chapters/Prodrugs';
import { AntiTubercularNotes } from './Chapters/AntiTubercular';
import { UrinaryTractNotes } from './Chapters/UrinaryTract';
import { AntiviralNotes } from './Chapters/Antiviral';
import { AntifungalNotes } from './Chapters/Antifungal';
import { AntiProtozoalNotes } from './Chapters/AntiProtozoal';
import { AnthelminticsNotes } from './Chapters/Anthelmintics';
import { SulfonamidesNotes } from './Chapters/Sulfonamides';
import { DrugDesignNotes } from './Chapters/DrugDesign';
import BP601TSynthesisNotes from './Chapters/BP601TSynthesis'; // NEWLY ADDED SYNTHESIS

// --- BP602T (Pharmacology III) Imports ---
import AntiAsthmaticNotes from './Chapters/AntiAsthmatic';
import RespiratorySystemNotes from './Chapters/RespiratorySystem';
import GastrointestinalTractNotes from './Chapters/GastrointestinalTract';
import ChemotherapyUnit2Notes from './Chapters/ChemotherapyUnit2';
import ChemotherapyUnit3Notes from './Chapters/ChemotherapyUnit3';
import ChemotherapyUnit4Notes from './Chapters/Unit4Notes';
import Unit5Notes from './Chapters/Unit5Notes';

// --- BP603T (Herbal Drug Technology) Imports ---
import HerbalDrugTechUnit1Notes from './Chapters/HerbalDrugTechUnit1';
import HerbalDrugTechUnit2Notes from './Chapters/HerbalDrugTechUnit2';
import HerbalDrugTechUnit3Notes from './Chapters/HerbalDrugTechUnit3';
import HerbalDrugTechUnit4Notes from './Chapters/HerbalDrugTechUnit4';
import HerbalDrugTechUnit5Notes from './Chapters/HerbalDrugTechUnit5';

// --- BP604T (Biopharmaceutics and Pharmacokinetics) Imports ---
import BiopharmaceuticsUnit1Notes from './Chapters/BiopharmaceuticsUnit1';
import BiopharmaceuticsUnit2Notes from './Chapters/BiopharmaceuticsUnit2';
import BiopharmaceuticsUnit3Notes from './Chapters/BiopharmaceuticsUnit3';
import BiopharmaceuticsUnit4Notes from './Chapters/BiopharmaceuticsUnit4';
import BiopharmaceuticsUnit5Notes from './Chapters/BiopharmaceuticsUnit5';

// --- BP605T (Pharmaceutical Biotechnology) Imports ---
import BiotechUnit1Notes from './Chapters/BiotechUnit1';
import BiotechUnit2Notes from './Chapters/BiotechUnit2';
import BiotechUnit3Notes from './Chapters/BiotechUnit3';
import BiotechUnit4Notes from './Chapters/BiotechUnit4';
import BiotechUnit5Notes from './Chapters/BiotechUnit5';

// --- BP606T (Quality Assurance) Imports ---
import QualityAssuranceUnit1Notes from './Chapters/QualityAssuranceUnit1';
import QualityAssuranceUnit2Notes from './Chapters/QualityAssuranceUnit2';
import QualityAssuranceUnit3Notes from './Chapters/QualityAssuranceUnit3';
import QualityAssuranceUnit4Notes from './Chapters/QualityAssuranceUnit4';
import QualityAssuranceUnit5Notes from './Chapters/QualityAssuranceUnit5';


// ==========================================
// --- LMS STUDY PORTAL DATA STRUCTURE ---
// ==========================================
export const PORTAL_SUBJECTS = {
    6: [
        { id: "BP601T", name: "Medicinal Chemistry III" },
        { id: "BP602T", name: "Pharmacology III" },
        { id: "BP603T", name: "Herbal Drug Technology" },
        { id: "BP604T", name: "Biopharmaceutics & Pharmacokinetics" },
        { id: "BP605T", name: "Pharmaceutical Biotechnology" },
        { id: "BP606T", name: "Quality Assurance" }
    ],
    default: [ { id: "SUB1", name: "Pharmaceutical Analysis" } ]
};

export const PORTAL_UNITS = ["Unit I", "Unit II", "Unit III", "Unit IV", "Unit V"];

// Organized exactly as per Syllabus
export const PORTAL_CHAPTERS = {
    // --- BP601T Chapters ---
    "BP601T": {
        "Unit I": ["Penicillins", "Cephalosporins", "Beta-Lactamase Inhibitors", "Monobactams", "Aminoglycosides", "Tetracyclines"],
        "Unit II": ["Macrolides", "Clindamycin", "Chloramphenicol", "Antimalarials", "Biguanides & Misc.", "Prodrugs"],
        "Unit III": ["Anti-tubercular Agents", "Urinary Tract Anti-infectives", "Antiviral Agents"],
        "Unit IV": ["Antifungal Agents", "Anti-Protozoal Agents", "Anthelmintic Agents", "Sulfonamides & Sulfones"],
        "Unit V": [
            "Introduction to Drug Design", 
            "Combinatorial Chemistry",
            "Synthesis of Important Drugs (Complete List)" // SYNTHESIS LINK ADDED HERE
        ]
    },
    // --- BP602T Chapters ---
    "BP602T": {
        "Unit I": [
            "Anti-asthmatic drugs",
            "Drugs used in the management of COPD",
            "Expectorants and antitussives",
            "Nasal decongestants",
            "Respiratory stimulants",
            "Antiulcer agents",
            "Drugs for constipation and diarrhoea",
            "Appetite stimulants and suppressants",
            "Digestants and carminatives",
            "Emetics and anti-emetics"
        ],
        "Unit II": [
            "General principles of chemotherapy",
            "Sulfonamides and cotrimoxazole",
            "Antibiotics- Penicillins, cephalosporins, chloramphenicol, macrolides, quinolones and fluoroquinolins, tetracycline and aminoglycosides"
        ],
        "Unit III": [
            "Antitubercular agents",
            "Antileprotic agents",
            "Antifungal agents",
            "Antiviral drugs",
            "Anthelmintics",
            "Antimalarial drugs",
            "Antiamoebic agents"
        ],
        "Unit IV": [
            "Urinary tract infections and sexually transmitted diseases",
            "Chemotherapy of malignancy",
            "Immunostimulants",
            "Immunosuppressant",
            "Protein drugs, monoclonal antibodies, target drugs to antigen, biosimilars"
        ],
        "Unit V": [
            "Definition and basic knowledge of acute, subacute and chronic toxicity",
            "Definition and basic knowledge of genotoxicity, carcinogenicity, teratogenicity and mutagenicity",
            "General principles of treatment of poisoning",
            "Clinical symptoms and management of barbiturates, morphine, organophosphorus compound and lead, mercury and arsenic poisoning",
            "Definition of rhythm and cycles",
            "Biological clock and their significance leading to chronotherapy"
        ]
    },
    // --- BP603T Chapters ---
    "BP603T": {
        "Unit I": [
            "Herbs as raw materials",
            "Biodynamic Agriculture",
            "Indian Systems of Medicine"
        ],
        "Unit II": [
            "Nutraceuticals: General aspects, Market, growth, scope and types of products",
            "Role of Nutraceuticals in ailments like Diabetes, CVS diseases, Cancer, IBS, GI diseases",
            "Study of herbs as health food: Alfaalfa, Chicory, Ginger, Fenugreek, Garlic, Honey, Amla, Ginseng, Ashwagandha, Spirulina",
            "Herbal-Drug and Herb-Food Interactions: Hypercium, kava-kava, Ginkobiloba, Ginseng, Garlic, Pepper & Ephedra"
        ],
        "Unit III": [
            "Herbal Cosmetics: Sources and description of raw materials of herbal origin",
            "Herbal Excipients: Significance of substances of natural origin as excipients",
            "Herbal Formulations: Conventional formulations and Novel dosage forms like phytosomes"
        ],
        "Unit IV": [
            "Evaluation of Drugs: WHO & ICH guidelines, Stability testing",
            "Patenting and Regulatory requirements: Definitions of IPR, Patent, Biopiracy",
            "Patenting aspects of Traditional Knowledge: Case study of Curcuma & Neem",
            "Regulatory Issues in India: ASU DTAB, ASU DCC, Schedule Z"
        ],
        "Unit V": [
            "General Introduction to Herbal Industry: Present scope and future prospects",
            "Plant-based industries and institutions involved in work on medicinal and aromatic plants in India",
            "Schedule T - Good Manufacturing Practice of Indian systems of medicine: Components and objectives",
            "Infrastructural requirements, working space, storage area, machinery, SOPs, health & hygiene, documentation"
        ]
    },
    // --- BP604T Chapters ---
    "BP604T": {
        "Unit I": [
            "Introduction to Biopharmaceutics",
            "Mechanisms of drug absorption through GIT",
            "Factors influencing drug absorption",
            "Distribution: Tissue permeability, protein binding of drugs",
            "Kinetics of protein binding and clinical significance"
        ],
        "Unit II": [
            "Elimination: Drug metabolism and basic metabolic pathways",
            "Renal excretion of drugs and factors affecting it",
            "Renal clearance and Non-renal routes of drug excretion",
            "Bioavailability and Bioequivalence: Definitions, absolute and relative",
            "In-vitro drug dissolution models and IVIVC",
            "Methods to enhance the dissolution rates and bioavailability"
        ],
        "Unit III": [
            "Pharmacokinetics: Definition and introduction, Compartment models, Non compartment models, physiological models",
            "One compartment open model: Intravenous Injection (Bolus)",
            "One compartment open model: Intravenous infusion",
            "One compartment open model: Extra vascular administrations",
            "Pharmacokinetics parameters: KE, t1/2, Vd, AUC, Ka, ClT and CLR - definitions and significance"
        ],
        "Unit IV": [
            "Multicompartment models: Two compartment open model. IV bolus",
            "Kinetics of multiple dosing, steady state drug levels",
            "Calculation of loading and maintenance doses and their significance in clinical settings"
        ],
        "Unit V": [
            "Nonlinear Pharmacokinetics: Introduction and Factors causing Non-linearity",
            "Michaelis-menton method of estimating parameters",
            "Explanation with example of drugs showing nonlinear kinetics"
        ]
    },
    // --- BP605T Chapters ---
    "BP605T": {
        "Unit I": [
            "Brief introduction to Biotechnology with reference to Pharmaceutical Sciences",
            "Enzyme Biotechnology- Methods of enzyme immobilization and applications",
            "Biosensors- Working and applications of biosensors in Pharmaceutical Industries",
            "Brief introduction to Protein Engineering",
            "Use of microbes in industry. Production of Enzymes",
            "Basic principles of genetic engineering"
        ],
        "Unit II": [
            "Study of cloning vectors, restriction endonucleases and DNA ligase",
            "Recombinant DNA technology. Application of genetic engineering in medicine",
            "Application of r DNA technology and genetic engineering in the production of: Interferon, Vaccines- hepatitis- B, Hormones-Insulin",
            "Brief introduction to PCR"
        ],
        "Unit III": [
            "Types of immunity- humoral immunity, cellular immunity",
            "Structure of Immunoglobulins and Structure and Function of MHC",
            "Hypersensitivity reactions, Immune stimulation and Immune suppressions",
            "General method of the preparation of bacterial vaccines, toxoids, viral vaccine, antitoxins",
            "Storage conditions and stability of official vaccines",
            "Hybridoma technology- Production, Purification and Applications",
            "Blood products and Plasma Substitutes"
        ],
        "Unit IV": [
            "Immuno blotting techniques- ELISA, Western blotting, Southern blotting",
            "Genetic organization of Eukaryotes and Prokaryotes",
            "Microbial genetics including transformation, transduction, conjugation, plasmids and transposons",
            "Introduction to Microbial biotransformation and applications",
            "Mutation: Types of mutation/mutants"
        ],
        "Unit V": [
            "Fermentation methods and general requirements, study of media, equipments, sterilization methods, aeration process, stirring",
            "Large scale production fermenter design and its various controls",
            "Study of the production of - penicillins, citric acid, Vitamin B12, Glutamic acid, Griseofulvin",
            "Blood Products: Collection, Processing and Storage of whole human blood, dried human plasma, plasma Substitutes"
        ]
    },
    // --- BP606T Chapters ---
    "BP606T": {
        "Unit I": [
            "Quality Assurance and Quality Management concepts",
            "Total Quality Management (TQM)",
            "ICH Guidelines: QSEM overview, Q-series and stability testing",
            "Quality by design (QbD)",
            "ISO 9000 & ISO14000",
            "NABL accreditation"
        ],
        "Unit II": [
            "Organization and personnel: Personnel responsibilities, training, hygiene and personal records",
            "Premises: Design, construction and plant layout, maintenance, sanitation",
            "Environmental control, utilities and maintenance of sterile areas, control of contamination",
            "Equipments and raw materials: Equipment selection, purchase specifications, maintenance",
            "Purchase specifications and maintenance of stores for raw materials"
        ],
        "Unit III": [
            "Quality Control: Quality control test for containers, rubber closures and secondary packing materials",
            "Good Laboratory Practices: General Provisions, Organization and Personnel",
            "Facilities, Equipment, Testing Facilities Operation, Test and Control Articles",
            "Protocol for Conduct of a Nonclinical Laboratory Study, Records and Reports",
            "Disqualification of Testing Facilities"
        ],
        "Unit IV": [
            "Complaints: Complaints and evaluation of complaints, Handling of return good, recalling and waste disposal",
            "Document maintenance in pharmaceutical industry: Batch Formula Record, Master Formula Record, SOP",
            "Quality audit, Quality Review and Quality documentation, Reports and documents, distribution records"
        ],
        "Unit V": [
            "Calibration and Validation: Introduction, definition and general principles",
            "Importance and scope of validation, types of validation, validation master plan",
            "Calibration of pH meter, Qualification of UV-Visible spectrophotometer",
            "General principles of Analytical method Validation",
            "Warehousing: Good warehousing practice, materials management"
        ]
    }
};

// ==========================================
// 2. MASTER LINK-UP: MERGING ALL NOTES TOGETHER
// ==========================================
export const CHAPTER_NOTES = {
    // ==========================================
    // --- BP601T (Medicinal Chemistry III) Notes ---
    // ==========================================
    // UNIT I
    "Penicillins": PenicillinsNotes,
    "Cephalosporins": CephalosporinsNotes,
    "Beta-Lactamase Inhibitors": BetaLactamaseInhibitorsNotes,
    "Monobactams": MonobactamsNotes,
    "Aminoglycosides": AminoglycosidesNotes,
    "Tetracyclines": TetracyclinesNotes,

    // UNIT II
    "Macrolides": MacrolidesNotes,
    "Clindamycin": ClindamycinNotes,
    "Chloramphenicol": ChloramphenicolNotes,
    "Antimalarials": AntimalarialsNotes,
    "Biguanides & Misc.": AntimalarialsNotes, // Proguanil is covered inside the Antimalarials notes
    "Prodrugs": ProdrugsNotes,

    // UNIT III
    "Anti-tubercular Agents": AntiTubercularNotes,
    "Urinary Tract Anti-infectives": UrinaryTractNotes,
    "Antiviral Agents": AntiviralNotes,

    // UNIT IV
    "Antifungal Agents": AntifungalNotes,
    "Anti-Protozoal Agents": AntiProtozoalNotes,
    "Anthelmintic Agents": AnthelminticsNotes,
    "Sulfonamides & Sulfones": SulfonamidesNotes,

    // UNIT V
    "Introduction to Drug Design": DrugDesignNotes,
    "Combinatorial Chemistry": DrugDesignNotes, // Combinatorial chemistry is covered inside the Drug Design notes
    "Synthesis of Important Drugs (Complete List)": BP601TSynthesisNotes, // SYNTHESIS NOTES LINKED HERE

    // ==========================================
    // --- BP602T (Pharmacology III) Notes ---
    // ==========================================
    // UNIT I
    "Anti-asthmatic drugs": AntiAsthmaticNotes,
    "Drugs used in the management of COPD": RespiratorySystemNotes,
    "Expectorants and antitussives": RespiratorySystemNotes,
    "Nasal decongestants": RespiratorySystemNotes,
    "Respiratory stimulants": RespiratorySystemNotes,
    "Antiulcer agents": GastrointestinalTractNotes,
    "Drugs for constipation and diarrhoea": GastrointestinalTractNotes,
    "Appetite stimulants and suppressants": GastrointestinalTractNotes,
    "Digestants and carminatives": GastrointestinalTractNotes,
    "Emetics and anti-emetics": GastrointestinalTractNotes,

    // UNIT II
    "General principles of chemotherapy": ChemotherapyUnit2Notes,
    "Sulfonamides and cotrimoxazole": ChemotherapyUnit2Notes,
    "Antibiotics- Penicillins, cephalosporins, chloramphenicol, macrolides, quinolones and fluoroquinolins, tetracycline and aminoglycosides": ChemotherapyUnit2Notes,

    // UNIT III
    "Antitubercular agents": ChemotherapyUnit3Notes,
    "Antileprotic agents": ChemotherapyUnit3Notes,
    "Antifungal agents": ChemotherapyUnit3Notes,
    "Antiviral drugs": ChemotherapyUnit3Notes,
    "Anthelmintics": ChemotherapyUnit3Notes,
    "Antimalarial drugs": ChemotherapyUnit3Notes,
    "Antiamoebic agents": ChemotherapyUnit3Notes,

    // UNIT IV
    "Urinary tract infections and sexually transmitted diseases": ChemotherapyUnit4Notes,
    "Chemotherapy of malignancy": ChemotherapyUnit4Notes,
    "Immunostimulants": ChemotherapyUnit4Notes,
    "Immunosuppressant": ChemotherapyUnit4Notes,
    "Protein drugs, monoclonal antibodies, target drugs to antigen, biosimilars": ChemotherapyUnit4Notes,

    // UNIT V
    "Definition and basic knowledge of acute, subacute and chronic toxicity": Unit5Notes,
    "Definition and basic knowledge of genotoxicity, carcinogenicity, teratogenicity and mutagenicity": Unit5Notes,
    "General principles of treatment of poisoning": Unit5Notes,
    "Clinical symptoms and management of barbiturates, morphine, organophosphorus compound and lead, mercury and arsenic poisoning": Unit5Notes,
    "Definition of rhythm and cycles": Unit5Notes,
    "Biological clock and their significance leading to chronotherapy": Unit5Notes,

    // ==========================================
    // --- BP603T (Herbal Drug Technology) Notes ---
    // ==========================================
    // UNIT I
    "Herbs as raw materials": HerbalDrugTechUnit1Notes,
    "Biodynamic Agriculture": HerbalDrugTechUnit1Notes,
    "Indian Systems of Medicine": HerbalDrugTechUnit1Notes,

    // UNIT II
    "Nutraceuticals: General aspects, Market, growth, scope and types of products": HerbalDrugTechUnit2Notes,
    "Role of Nutraceuticals in ailments like Diabetes, CVS diseases, Cancer, IBS, GI diseases": HerbalDrugTechUnit2Notes,
    "Study of herbs as health food: Alfaalfa, Chicory, Ginger, Fenugreek, Garlic, Honey, Amla, Ginseng, Ashwagandha, Spirulina": HerbalDrugTechUnit2Notes,
    "Herbal-Drug and Herb-Food Interactions: Hypercium, kava-kava, Ginkobiloba, Ginseng, Garlic, Pepper & Ephedra": HerbalDrugTechUnit2Notes,

    // UNIT III
    "Herbal Cosmetics: Sources and description of raw materials of herbal origin": HerbalDrugTechUnit3Notes,
    "Herbal Excipients: Significance of substances of natural origin as excipients": HerbalDrugTechUnit3Notes,
    "Herbal Formulations: Conventional formulations and Novel dosage forms like phytosomes": HerbalDrugTechUnit3Notes,

    // UNIT IV
    "Evaluation of Drugs: WHO & ICH guidelines, Stability testing": HerbalDrugTechUnit4Notes,
    "Patenting and Regulatory requirements: Definitions of IPR, Patent, Biopiracy": HerbalDrugTechUnit4Notes,
    "Patenting aspects of Traditional Knowledge: Case study of Curcuma & Neem": HerbalDrugTechUnit4Notes,
    "Regulatory Issues in India: ASU DTAB, ASU DCC, Schedule Z": HerbalDrugTechUnit4Notes,

    // UNIT V
    "General Introduction to Herbal Industry: Present scope and future prospects": HerbalDrugTechUnit5Notes,
    "Plant-based industries and institutions involved in work on medicinal and aromatic plants in India": HerbalDrugTechUnit5Notes,
    "Schedule T - Good Manufacturing Practice of Indian systems of medicine: Components and objectives": HerbalDrugTechUnit5Notes,
    "Infrastructural requirements, working space, storage area, machinery, SOPs, health & hygiene, documentation": HerbalDrugTechUnit5Notes,

    // ==========================================
    // --- BP604T (Biopharmaceutics & Pharmacokinetics) Notes ---
    // ==========================================
    // UNIT I
    "Introduction to Biopharmaceutics": BiopharmaceuticsUnit1Notes,
    "Mechanisms of drug absorption through GIT": BiopharmaceuticsUnit1Notes,
    "Factors influencing drug absorption": BiopharmaceuticsUnit1Notes,
    "Distribution: Tissue permeability, protein binding of drugs": BiopharmaceuticsUnit1Notes,
    "Kinetics of protein binding and clinical significance": BiopharmaceuticsUnit1Notes,

    // UNIT II
    "Elimination: Drug metabolism and basic metabolic pathways": BiopharmaceuticsUnit2Notes,
    "Renal excretion of drugs and factors affecting it": BiopharmaceuticsUnit2Notes,
    "Renal clearance and Non-renal routes of drug excretion": BiopharmaceuticsUnit2Notes,
    "Bioavailability and Bioequivalence: Definitions, absolute and relative": BiopharmaceuticsUnit2Notes,
    "In-vitro drug dissolution models and IVIVC": BiopharmaceuticsUnit2Notes,
    "Methods to enhance the dissolution rates and bioavailability": BiopharmaceuticsUnit2Notes,

    // UNIT III
    "Pharmacokinetics: Definition and introduction, Compartment models, Non compartment models, physiological models": BiopharmaceuticsUnit3Notes,
    "One compartment open model: Intravenous Injection (Bolus)": BiopharmaceuticsUnit3Notes,
    "One compartment open model: Intravenous infusion": BiopharmaceuticsUnit3Notes,
    "One compartment open model: Extra vascular administrations": BiopharmaceuticsUnit3Notes,
    "Pharmacokinetics parameters: KE, t1/2, Vd, AUC, Ka, ClT and CLR - definitions and significance": BiopharmaceuticsUnit3Notes,

    // UNIT IV
    "Multicompartment models: Two compartment open model. IV bolus": BiopharmaceuticsUnit4Notes,
    "Kinetics of multiple dosing, steady state drug levels": BiopharmaceuticsUnit4Notes,
    "Calculation of loading and maintenance doses and their significance in clinical settings": BiopharmaceuticsUnit4Notes,

    // UNIT V
    "Nonlinear Pharmacokinetics: Introduction and Factors causing Non-linearity": BiopharmaceuticsUnit5Notes,
    "Michaelis-menton method of estimating parameters": BiopharmaceuticsUnit5Notes,
    "Explanation with example of drugs showing nonlinear kinetics": BiopharmaceuticsUnit5Notes,

    // ==========================================
    // --- BP605T (Pharmaceutical Biotechnology) Notes ---
    // ==========================================
    // UNIT I
    "Brief introduction to Biotechnology with reference to Pharmaceutical Sciences": BiotechUnit1Notes,
    "Enzyme Biotechnology- Methods of enzyme immobilization and applications": BiotechUnit1Notes,
    "Biosensors- Working and applications of biosensors in Pharmaceutical Industries": BiotechUnit1Notes,
    "Brief introduction to Protein Engineering": BiotechUnit1Notes,
    "Use of microbes in industry. Production of Enzymes": BiotechUnit1Notes,
    "Basic principles of genetic engineering": BiotechUnit1Notes,

    // UNIT II
    "Study of cloning vectors, restriction endonucleases and DNA ligase": BiotechUnit2Notes,
    "Recombinant DNA technology. Application of genetic engineering in medicine": BiotechUnit2Notes,
    "Application of r DNA technology and genetic engineering in the production of: Interferon, Vaccines- hepatitis- B, Hormones-Insulin": BiotechUnit2Notes,
    "Brief introduction to PCR": BiotechUnit2Notes,

    // UNIT III
    "Types of immunity- humoral immunity, cellular immunity": BiotechUnit3Notes,
    "Structure of Immunoglobulins and Structure and Function of MHC": BiotechUnit3Notes,
    "Hypersensitivity reactions, Immune stimulation and Immune suppressions": BiotechUnit3Notes,
    "General method of the preparation of bacterial vaccines, toxoids, viral vaccine, antitoxins": BiotechUnit3Notes,
    "Storage conditions and stability of official vaccines": BiotechUnit3Notes,
    "Hybridoma technology- Production, Purification and Applications": BiotechUnit3Notes,
    "Blood products and Plasma Substitutes": BiotechUnit3Notes,

    // UNIT IV
    "Immuno blotting techniques- ELISA, Western blotting, Southern blotting": BiotechUnit4Notes,
    "Genetic organization of Eukaryotes and Prokaryotes": BiotechUnit4Notes,
    "Microbial genetics including transformation, transduction, conjugation, plasmids and transposons": BiotechUnit4Notes,
    "Introduction to Microbial biotransformation and applications": BiotechUnit4Notes,
    "Mutation: Types of mutation/mutants": BiotechUnit4Notes,

    // UNIT V
    "Fermentation methods and general requirements, study of media, equipments, sterilization methods, aeration process, stirring": BiotechUnit5Notes,
    "Large scale production fermenter design and its various controls": BiotechUnit5Notes,
    "Study of the production of - penicillins, citric acid, Vitamin B12, Glutamic acid, Griseofulvin": BiotechUnit5Notes,
    "Blood Products: Collection, Processing and Storage of whole human blood, dried human plasma, plasma Substitutes": BiotechUnit5Notes,

    // ==========================================
    // --- BP606T (Quality Assurance) Notes ---
    // ==========================================
    // UNIT I
    "Quality Assurance and Quality Management concepts": QualityAssuranceUnit1Notes,
    "Total Quality Management (TQM)": QualityAssuranceUnit1Notes,
    "ICH Guidelines: QSEM overview, Q-series and stability testing": QualityAssuranceUnit1Notes,
    "Quality by design (QbD)": QualityAssuranceUnit1Notes,
    "ISO 9000 & ISO14000": QualityAssuranceUnit1Notes,
    "NABL accreditation": QualityAssuranceUnit1Notes,

    // UNIT II
    "Organization and personnel: Personnel responsibilities, training, hygiene and personal records": QualityAssuranceUnit2Notes,
    "Premises: Design, construction and plant layout, maintenance, sanitation": QualityAssuranceUnit2Notes,
    "Environmental control, utilities and maintenance of sterile areas, control of contamination": QualityAssuranceUnit2Notes,
    "Equipments and raw materials: Equipment selection, purchase specifications, maintenance": QualityAssuranceUnit2Notes,
    "Purchase specifications and maintenance of stores for raw materials": QualityAssuranceUnit2Notes,

    // UNIT III
    "Quality Control: Quality control test for containers, rubber closures and secondary packing materials": QualityAssuranceUnit3Notes,
    "Good Laboratory Practices: General Provisions, Organization and Personnel": QualityAssuranceUnit3Notes,
    "Facilities, Equipment, Testing Facilities Operation, Test and Control Articles": QualityAssuranceUnit3Notes,
    "Protocol for Conduct of a Nonclinical Laboratory Study, Records and Reports": QualityAssuranceUnit3Notes,
    "Disqualification of Testing Facilities": QualityAssuranceUnit3Notes,

    // UNIT IV
    "Complaints: Complaints and evaluation of complaints, Handling of return good, recalling and waste disposal": QualityAssuranceUnit4Notes,
    "Document maintenance in pharmaceutical industry: Batch Formula Record, Master Formula Record, SOP": QualityAssuranceUnit4Notes,
    "Quality audit, Quality Review and Quality documentation, Reports and documents, distribution records": QualityAssuranceUnit4Notes,

    // UNIT V
    "Calibration and Validation: Introduction, definition and general principles": QualityAssuranceUnit5Notes,
    "Importance and scope of validation, types of validation, validation master plan": QualityAssuranceUnit5Notes,
    "Calibration of pH meter, Qualification of UV-Visible spectrophotometer": QualityAssuranceUnit5Notes,
    "General principles of Analytical method Validation": QualityAssuranceUnit5Notes,
    "Warehousing: Good warehousing practice, materials management": QualityAssuranceUnit5Notes
};

// ==========================================
// 3. VIRTUAL LAB SYLLABUS DATA 
// ==========================================
export const SYLLABUS_DATA = [
  { unit: "UNIT - I (Antibiotics)", chapters: [{ name: "β-Lactam Antibiotics", drugs: ["Penicillin", "Cephalosporins", "Monobactams"] }, { name: "Aminoglycosides", drugs: ["Streptomycin", "Neomycin", "Kanamycin"] }, { name: "Tetracyclines", drugs: ["Tetracycline", "Oxytetracycline", "Chlortetracycline", "Minocycline", "Doxycycline"] }] },
  { unit: "UNIT - II (Macrolides & Antimalarials)", chapters: [{ name: "Macrolide & Miscellaneous", drugs: ["Erythromycin", "Clarithromycin", "Azithromycin", "Chloramphenicol", "Clindamycin"] }, { name: "Antimalarials (Quinolines)", drugs: ["Quinine", "Chloroquine", "Amodiaquine", "Primaquine", "Pamaquine", "Quinacrine", "Mefloquine"] }, { name: "Biguanides & Misc.", drugs: ["Cycloguanil", "Proguanil", "Pyrimethamine", "Artesunate", "Artemether", "Atovaquone"] }, { name: "Prodrugs", drugs: ["Prodrugs"] }] },
  { unit: "UNIT - III (Anti-tubercular, UTI & Antiviral)", chapters: [{ name: "Anti-tubercular Agents", drugs: ["Isoniazid", "Ethionamide", "Ethambutol", "Pyrazinamide", "Rifampicin", "Rifabutin", "Cycloserine", "Capreomycin"] }, { name: "Urinary Tract Anti-infectives", drugs: ["Nalidixic Acid", "Norfloxacin", "Enoxacin", "Ciprofloxacin", "Ofloxacin", "Lomefloxacin", "Sparfloxacin", "Gatifloxacin", "Moxifloxacin", "Furazolidine", "Nitrofurantoin", "Methenamine"] }, { name: "Antiviral Agents", drugs: ["Amantadine", "Rimantadine", "Idoxuridine", "Acyclovir", "Gancyclovir", "Zidovudine", "Didanosine", "Zalcitabine", "Lamivudine", "Loviride", "Delavirdine", "Ribavirin", "Saquinavir", "Indinavir", "Ritonavir"] }] },
  { unit: "UNIT - IV (Antifungal, Antiprotozoal & Sulphas)", chapters: [{ name: "Antifungal Agents", drugs: ["Amphotericin-B", "Nystatin", "Natamycin", "Griseofulvin", "Clotrimazole", "Econazole", "Butoconazole", "Oxiconazole", "Tioconazole", "Miconazole", "Ketoconazole", "Terconazole", "Itraconazole", "Fluconazole", "Naftifine", "Tolnaftate"] }, { name: "Anti-protozoal & Anthelmintics", drugs: ["Metronidazole", "Tinidazole", "Ornidazole", "Diloxanide", "Iodoquinol", "Pentamidine", "Eflornithine", "Diethylcarbamazine", "Thiabendazole", "Mebendazole", "Albendazole", "Niclosamide", "Praziquantel", "Ivermectin"] }, { name: "Sulphonamides and Sulfones", drugs: ["Sulphamethizole", "Sulfisoxazole", "Sulphamethizine", "Sulfacetamide", "Sulphapyridine", "Sulfamethoxazole", "Sulphadiazine", "Sulfasalazine", "Trimethoprim", "Cotrimoxazole", "Dapsone"] }] }
];